<template>
  <div>
    <div class="xsmall-hide small-hide bg-1">
    </div>
    <div class="medium-hide large-hide xlarge-hide">
      <img src="../assets/naniungo-slide-21.jpg">
    </div>
    <div>
    </div>
    <div class="message"
         style="padding-left:10vw;padding-right:10vw; height:auto;">
      <h3 v-if="answer == 'yes'">
        Vielen Dank für Ihr Vertrauen, dass wir Ihre Daten speichern dürfen.
        <br>
        <br>
        Ihre Unterlagen werden in unserem CRM System hinterlegt. Wir werden Ihre Daten nur mit Ihrer jeweils erteilten Genehmigung unseren Kunden zur Verfügung stellen.
        Sollten Sie Fragen zum Thema Datenschutz haben, können Sie sich jederzeit mit unserem Datenschutzbeauftragen unter datenschutz@naniungo.com in Verbindung setzen.
        <br>
        <br>
        Ihr naniungo® Deutschland Team
      </h3>
      <h3 v-if="answer == 'no'">
        Vielen Dank für Ihr Vertrauen, dass wir Ihre Daten in der Vergangenheit speichern durften.
        <br>
        <br>
        Wir werden innerhalb der nächsten 2 Werktage Ihre Unterlagen, sowie sämtliche von uns gespeicherten Kontaktdaten oder Email Schriftverkehr zur Ihrer Person aus unserem System löschen.
        Wir würden uns freuen, wenn Sie mit unserer Dienstleistung zufrieden waren und wir in der Zukunft noch einmal für weitere Themen einen erneuten Kontakt aufbauen.
        <br>
        <br>
        Ihr naniungo® Deutschland Team
      </h3>
    </div>
  </div>

</template>

<script>
export default {
  name: "Vakanzen",
  data() {
    return {
      vacancy: [],
      links: [
        {
          name: "Home",
          route: "naniungo"
        },
        {
          name: "Über Uns",
          route: "about"
        },
        {
          name: "Themenschwerpunkte",
          route: "themen"
        },
        {
          name: "Karriere",
          route: "karriere"
        },
        {
          name: "Blog",
          route: "blog"
        }
      ],
      answer: ""
    };
  },
  computed: {},
  created() {
    this.answer = this.$route.params.id;
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/shared.scss";
.bg-1 {
  background: url("../assets/naniungo-slide-21.jpg") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 400px;
  background-position: right 0px top -80px !important;
}

@media (min-width: 1600px) {
  .bg-1 {
    height: 500px;
  }
}
@media (min-width: 1800px) {
  .bg-1 {
    height: 500px;
    background-position: right 0px top -150px !important;
  }
}

.profiles {
  margin-left: 10px;
  margin-right: 10px;

  .md-card-header {
    padding: 16px;
  }

  .md-card {
    margin: 10px;
    width: 55vw;
    display: inline-block;
    vertical-align: top;
  }

  @media (min-width: 300px) and (max-width: 1300px) {
    .md-card {
      width: 50vw;
    }
  }

  .md-title {
    // margin-right:80px !important;
    h3 {
      font-size: 30px !important;
      margin-top: -2px;
      font-weight: 900;
    }
  }
  .md-subhead {
    // margin-right:80px !important;
    p {
      font-size: 16px !important;
      color: $primary-font;
    }
  }
  .md-card-actions {
    margin-bottom: 5px;
    margin-right: 5px;
  }
}

@media (min-width: 947px) {
  .blog {
    h1 {
      font-size: 50px;
      line-height: 56px;
      font-weight: 300;
    }
    p {
      font-size: 20px;
      line-height: 28px;
    }
  }
}
@media (max-width: 946px) {
  .blog {
    h1 {
      font-size: 30px;
      line-height: 36px;
      font-weight: 300;
    }
    p {
      font-size: 15px;
      line-height: 20px;
    }
  }
}

.blog {
  margin-left: 10vw;
  margin-right: 10vw;
}
</style>
